"use client";

import { Box, Grid, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { ScrollReveal } from "./ScrollReveal";
import { SectionLabel } from "./SectionLabel";
import { Emoji } from "@/_components/ui/Emoji/Emoji";
import { EmojiKey } from "@/_components/ui/Emoji/emojiList";

const ORDER = [
  "dashboard",
  "ai_screening",
  "talent_pool",
  "job-management",
  "storage",
  "search",
] as const;

const ICONS = [
  "chart-increasing",
  "robot",
  "bullseye",
  "card-file-box",
  "locked-with-key",
  "sparkles",
];

export function LandingFeaturesDark() {
  const tFeat = useTranslations("landing.redesign.features_section");
  const tProducts = useTranslations("landing.products.items");

  return (
    <Box
      as="section"
      id="products"
      aria-labelledby="landing-features-heading"
      py={{ base: 16, md: 36 }}
      px={{ base: 4, md: 0 }}
      bg="neutral.900"
    >
      <Box maxW="1100px" mx="auto">
        <ScrollReveal>
          <SectionLabel lineColor="primary.400" textColor="primary.300">
            {tFeat("label")}
          </SectionLabel>
          <Text
            as="h2"
            id="landing-features-heading"
            fontFamily="heading"
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="semibold"
            letterSpacing="-1px"
            color="white"
            lineHeight={1.1}
            mb={3}
          >
            {tFeat("title_line1")}
            <br />
            {tFeat("title_line2")}
          </Text>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <Grid
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            }}
            gap="1px"
            bg="whiteAlpha.200"
            borderRadius="16px"
            overflow="hidden"
            mt={12}
          >
            {ORDER.map((key, i) => (
              <Box
                key={key}
                bg="neutral.900"
                p={{ base: 5, md: 8 }}
                position="relative"
                overflow="hidden"
                transition="background 0.25s"
                _hover={{
                  bg: "neutral.800",
                  _before: { opacity: 0.06 },
                }}
                _before={{
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  bg: "primary.500",
                  opacity: 0,
                  transition: "opacity 0.3s",
                  pointerEvents: "none",
                }}
              >
                <Text
                  fontFamily="heading"
                  textStyle="xs"
                  fontWeight="bold"
                  color="whiteAlpha.300"
                  letterSpacing="0.1em"
                  mb={5}
                >
                  {String(i + 1).padStart(2, "0")}
                </Text>
                <Box mb={4}>
                  <Emoji
                    emoji={ICONS[i] as EmojiKey}
                    size={8}
                    label={tProducts(`${key}.title`)}
                  />
                </Box>
                <Text
                  fontFamily="heading"
                  textStyle="sm"
                  fontWeight="700"
                  color="white"
                  mb={2}
                >
                  {tProducts(`${key}.title`)}
                </Text>
                <Text textStyle="xs" color="whiteAlpha.600" lineHeight={1.65}>
                  {tProducts(`${key}.description`)}
                </Text>
              </Box>
            ))}
          </Grid>
        </ScrollReveal>
      </Box>
    </Box>
  );
}
